import { ActionButton, Button } from "@ds/ds-snam/react";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";
import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { AppUserGrant, AppUserRole, CalendarViewType, IAppUserProfile, UICommand } from "shared/constants";


interface ICalendarButtonsProps {
    calendarViewType: CalendarViewType
    setCommand: React.Dispatch<React.SetStateAction<UICommand | undefined>>;
}
const CalendarButtons: React.FC<ICalendarButtonsProps> = (props): JSX.Element => {
    const { t, i18n } = useTranslation(["b2b", "app"]);
    const appUserProfile: IAppUserProfile | undefined = useAppUser()?.userProfile;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    return (
        <>

            <Row>
                <div style={{ width: '100%', background: '', marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: 'fit-content', float: 'right' }}>

                        {props.calendarViewType === CalendarViewType.DRAFT &&
                            <>
                                <div style={{ width: 'fit-content', float: 'left' }}>
                                    <ActionButton
                                        actionsType="button"
                                        buttonLabel={t('calendar.popups.buttons.0')}//"Azioni"
                                        buttonVariant="secondary"
                                        buttonAriaLabel="action button aria text"
                                        menuAriaLabel="menu aria text"
                                        menuTitle="Azioni"
                                        menuActions={
                                            [
                                                {
                                                    id: UICommand.CALENDAR_SLOT_NOT_AVAILABLE,
                                                    label: t('calendar.popups.buttons.1'),//"Slot non disponibile",//
                                                    isDisabled:appUserRole===AppUserRole.READER
                                                },
                                                {
                                                    id: UICommand.CALENDAR_CONFIGURE,
                                                    label: t('calendar.popups.buttons.2'),//"Configura",//
                                                    isDisabled:appUserRole===AppUserRole.READER
                                                },
                                                {
                                                    id: UICommand.CALENDAR_DELETE_SLOTS,
                                                    label: t('calendar.popups.buttons.3'),//"Elimina più slot",//
                                                    isDisabled:appUserRole===AppUserRole.READER
                                                },
                                                {
                                                    id: UICommand.CALENDAR_NON_WORKING_DAYS_INSERT,
                                                    label: t('calendar.popups.buttons.12'),
                                                    isDisabled:appUserRole===AppUserRole.READER
                                                },
                                                {
                                                    id: UICommand.CALENDAR_NON_WORKING_DAYS_DELETE,
                                                    label: t('calendar.popups.buttons.13'),
                                                    isDisabled:appUserRole===AppUserRole.READER
                                                }
                                            ]
                                        }
                                        closeMenuAriaLabel="close menu aria text"
                                        //isDisabled={false}
                                        //zIndex={999}
                                        onClickAction={(event: Event) => {
                                            const command = (event as CustomEvent).detail.actionId;
                                            props.setCommand(command);
                                        }}
                                    ></ActionButton>
                                </div>
                                <div style={{ width: 'fit-content', float: 'right', marginLeft: '15px' }}>
                                    <Button
                                        buttonType="button"
                                        buttonUIVariant="primary"
                                        buttonSize="medium"
                                        buttonLabel={t('calendar.popups.buttons.5')}//</div>"Pubblica"
                                        buttonIcon=""
                                        isDisabled={appUserRole===AppUserRole.READER}
                                        buttonAriaLabel="credit button"
                                        onClick={() => {
                                            props.setCommand(UICommand.CALENDAR_PUBBLICATION);
                                        }}
                                    ></Button>
                                </div>
                            </>
                        }
                        {appUserProfile?.calendarGrants.includes(AppUserGrant.DELETE) &&
                            props.calendarViewType === CalendarViewType.PUBLIC &&
                            <div style={{ width: 'fit-content', float: 'right', marginLeft: '15px' }}>
                                <Button
                                    buttonType="button"
                                    buttonUIVariant="secondary"
                                    buttonSize="medium"
                                    buttonLabel={t('calendar.popups.buttons.4')}//"Elimina pubblicazione"
                                    buttonIcon=""
                                    isDisabled={false}
                                    buttonAriaLabel="credit button"
                                    onClick={() => {
                                        props.setCommand(UICommand.CALENDAR_DELETE_PUBBLICATION);
                                    }}
                                ></Button>
                            </div>
                        }
                        {((appUserRole===AppUserRole.TL_MANAGER || appUserRole===AppUserRole.ADMIN) && props.calendarViewType !== CalendarViewType.DRAFT) &&
                            <div style={{ width: 'fit-content', float: 'right', marginLeft: '15px' }}>
                                <Button
                                    buttonType="button"
                                    buttonUIVariant="primary"
                                    buttonSize="medium"
                                    buttonLabel={t('calendar.popups.buttons.15')}
                                    buttonIcon=""
                                    isDisabled={false}
                                    buttonAriaLabel="credit button"
                                    onClick={() => {
                                        props.setCommand(UICommand.CALENDAR_SLOT_NOT_AVAILABLE);
                                    }}
                                ></Button>
                            </div>
                        }
                        {((appUserRole===AppUserRole.SALES_PROFILE || appUserRole===AppUserRole.ADMIN) && props.calendarViewType !== CalendarViewType.DRAFT) &&
                            <div style={{ width: 'fit-content', float: 'right', marginLeft: '15px' }}>
                                <Button
                                    buttonType="button"
                                    buttonUIVariant="primary"
                                    buttonSize="medium"
                                    buttonLabel={t('calendar.popups.buttons.14')}
                                    buttonIcon=""
                                    isDisabled={false}
                                    buttonAriaLabel="credit button"
                                    onClick={() => {
                                        props.setCommand(UICommand.REVERT_RESERVATIONS);
                                    }}
                                ></Button>
                            </div>
                        }
                    </div>
                </div>
            </Row>
        </>
    );
}

export default CalendarButtons;